// extracted by mini-css-extract-plugin
export default {"error":"Error_error__ayWRm","iconWrapper":"Error_iconWrapper__xHGrQ"};